const ACCOUNT_TYPE = { // 햇갈릴 소지가 있어서 ACCT_TYPE(account_type)이라고 사용한다.
  USER: 1,
  DR: 2
}

const STATUS_CODE = {
  OK: 200,
  NOT_FOUND: 204,
  FAILED: 400,
  NO_DATA: 404, //(파이썬쪽 요청으로 204 -> 404로 보냄)
  ALREADY_EXISTS: 405, // 회원이 이미 존재할때  
  NOT_LOGIN: 409, // 로그인 차단  
  NOT_EXIST: 410,      //회원가입이 되어 있지 않을때
  FIRST_SNS_LOGIN: 420 // SNS 로그인 회원이 존재하지 않을때 
}

const AUTH_TYPE = {
  SELF: 1, // 자체인증
  FACEBOOK: 2, // 페이스북
  KAKAO: 3, // 카카오톡
  GOOGLE: 4, // 구글
  NAVER: 5, // 네이버
  APPLE: 6 // 애플
}

const UPLOAD_TYPE = {
  DR_IMG: 'dr_web/dr',
  HOSP_IMG: 'dr_web/hosp',
  USER_IMG: 'dr_web/user',
  DR_LIC_IMG: 'dr_web/dr_lic',

  PHARM_LIC_IMG: 'pharm_web/pharm_lic', // 면허증 이미지
  PHARM_BUS_IMG: 'pharm_web/pharm_bus', // 사업자등록증 이미지
  PHARM_ACC_IMG: 'pharm_web/pharm_acc', // 은행계좌번호 이미지

  MSG_ATTACH: 'dr_web/msg',
  DR_COMMENT: 'dr_web/comment',
  APP_IMG: 'apps',
  USER_APP_IMG: '',
  BANNER_EVENT: 'doc/banner/event',
  BANNER_MAIN: 'doc/banner/main',
  PHARM_IMG: 'pharm_web/pharm',
  PHARM_LIC_IMG: 'pharm_web/pharm_lic',
}

const IO_MSG = {
  REGISTER_DR: 1,
  REGISTER_SERVER: 2,
  NEW_DR_DATA: 3, // proxy 처리
  FROM_SERVER: 4,
  FROM_DR: 5
}

const OS_TYPE = {
  AOS: 1, // Android
  IOS: 2, // iOS
  WIN: 3 // Window
}

const COUNTRY_CODE = {
  KR: 82,
  US: 1
}

const ENV = {
  DEVELOPMENT: 'development',
  TESTING: 'testing',
  PRODUCTION: 'production'
}

const CONSULT_TYPE = {
  BOOKING: 1,
  QUICK: 2
}

const CONSULT_STATUS = {
  INIT: 0, // 접수 (결제전)
  PAID: 1, // 의사 수락대기(결제완료)
  READY: 2, // 의사 수락완료(상담가능상태) // 상담확정
  ON_COUNSULT: 3, // 상담중
  DONE: 5, // 정상종료
  CANCEL: 9 // 비정상 종료 + need cancel reason!
}

const DR_STATUS = {
  APPLY: 0, // 가입처리중
  NORMAL: 1, // 정상
  PAUSE: 2, // 일시정지
  // LEFT: 3, // 탈퇴(상담실 입장시) -> is_vailable 값을 사용한다.
  DELETE: 9 // 9
}

const USER_STATUS = {
  NORMAL: 1,
  PAUSE: 2,
  DELETE: 9
}

// 사용안함
// const DR_SEARCH_METHOD = Object.create(null);
// DR_SEARCH_METHOD.CLINIC = 'clinic'
// DR_SEARCH_METHOD.THEME = 'theme'

const CONSULT_ACTION = {
  NONE: 0,
  CONFIRM: 1, // 의사가 예약 승인을 하였을때
  ENTER: 2, // 상담실 입장
  START: 3, // 상담실 시작 버튼을 눌렀을때
  EXTEND: 4, // 상담중 연장신청
  LEAVE: 5, // 상담중 종료버튼(상담완료 or 강제나감)
  CANCEL: 9 // 상담 취소 버튼을 눌렸을 경우(상담받기전)
}

const PUSH_TYPE = {
  GENERAL: 1, // "메시지 알림", $drName . " 상담의로부터 메시지가 전달되었습니다." -> (예약시)
  ABLE_TO_CHAT: 5, // "상담실 채팅", 채팅이 가능합니다. ->(사용안함)
  CONSULT_START: 6, // "상담시작", "상담이 시작되었습니다." -> (의사가 카메라 버튼을 누를때:사용)
  CONSULT_END: 4, // "상담종료", "상담이 종료되었습니다." -> (의사가 종료할때)
  ASK_CONSULT_QUICK: 2, // "빠른상담 진행요청", "빠른상담을 진행요청합니다. -> (사용)
  ASK_CONSULT_BOOKING: 7 // "예약상담 입장안내", "예약상담에 참여하실 수 있습니다." -> (사용) // 예약상담시
}

const MOMENT = {
  FROM_MYSQL_FORMAT: '%Y-%m-%d %H:%i:%s',
  TO_MYSQL_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  TO_DATE_FORMAT: 'MM월 DD일',
  TO_TIME_FORMAT: 'HH:mm',
  SUNDAY: 0, // 일요일
  SATURDAY: 6 // 토요일
}

const IMG_PATH = {
  DR_PROFILE: '/static/dr-upload',
  DR_LICENSE: '/static/dr-license'
}

const RES_STATUS = {
  FILE_UPLOAD_FAILED: 120, // 파일 업로드 에러
  NOT_FOUND: 121, // "잘못된 이메일 형식입니다"
  TOKBOX_TOKEN_ERROR: 201, // 토큰 발급 에러, tokbox상담실이 존재하지 않음
  CONSULT_ENDED: 203, // 이미 종료된 상담정보입니다
  INVALID_REQUEST: 400, // "잘못된 요청정보입니다"; // 파라미터 이상
  DB_ERROR: 500, // 즉시 상담 기록 실패
  DB_NOT_FOUND: 404, // 의사정보 없음, 상담실 정보를 찾을 수 없습니다,
  CONSULT_QUICK_FAILED: 500, // 상담실 관련 에러, 상담실 등록 실패, 회원 토큰생성 실패, 상담실 세션생성 실패, 톡박스 없음
  IMP_TOKEN_FAILED: 501, // 토큰 발급 실패
  PAY_CANCEL_FAILED: 502, // 결제 취소 실패
  CONSULT_CANCEL_FAILED: 503, // 상담취소 실(유저가 취소)
  CONSULT_NOT_ABLE_TO_CANCEL: 403 // 상담취소가 가능한 상담이 아님.
}

const TRXN_TYPE = {
  PAID: 1,
  CANCEL: 2
}

const EVENT_STATUS = {
  INIT: 1, // 작성중
  READY: 2, // 게시대기
  ON_EVENT: 3, // 게시중
  PAUSE: 8, // 일시중지
  DONE: 5, // 종료
  CANCEL: 9 // 취소
}

const INSPECTION_STATUS = {
  INIT: 1, // 검수전
  REQUEST: 2, // 검수요청
  RETURN: 8, // 검수반려
  DONE: 5, // 검수승인
  CANCEL: 9 // 검수취소
}

const CONSULT_TYPE_IMM = 1
const CONSULT_TYPE_BOOK = 2
const DR_CORNFIRMED_YES = true
const DR_CORNFIRMED_NO = false

const ACCESS_TOKEN_KEY = 'user_token' // Todo: 가라로 존재하는거 나중에 지워주기

const getConstName = function (const_object, const_val) { // Object.is 로도 가능해 보인다.
  if (!const_val) return ''
  if (Object.is(const_object, CONSULT_TYPE)) {
    if (const_val === CONSULT_TYPE.QUICK) return '빠른상담'
    if (const_val === CONSULT_TYPE.BOOKING) return '예약상담'
  }

  if (Object.is(const_object, CONSULT_STATUS)) {
    if (const_val === CONSULT_STATUS.INIT) return '접수완료(결제대기중)'
    if (const_val === CONSULT_STATUS.PAID) return '결제완료(수락대기중)'
    if (const_val === CONSULT_STATUS.READY) return '상담확정'
    if (const_val === CONSULT_STATUS.ON_COUNSULT) return '상담중'
    if (const_val === CONSULT_STATUS.DONE) return '상담종료'
    if (const_val === CONSULT_STATUS.CANCEL) return '상담취소'
  }

  if (Object.is(const_object, CONSULT_ACTION)) {
    if (const_val === CONSULT_ACTION.ADMIT) return '예약 승인'
    if (const_val === CONSULT_ACTION.ENTER) return '(PUSH) 상담실 입장 요청'
    if (const_val === CONSULT_ACTION.START) return '(PUSH) 상담시작 요청'
    if (const_val === CONSULT_ACTION.EXTEND) return '상담중 연장신청'
    if (const_val === CONSULT_ACTION.LEAVE) return '(PUSH) 상담종료'
    if (const_val === CONSULT_ACTION.CANCEL) return '상담 취소 버튼을 눌렸을 경우(상담받기전)'
  }

  if (Object.is(const_object, EVENT_STATUS)) {
    if (const_val === EVENT_STATUS.INIT) return '작성중'
    if (const_val === EVENT_STATUS.READY) return '게시대기'
    if (const_val === EVENT_STATUS.ON_EVENT) return '게시중'
    if (const_val === EVENT_STATUS.PAUSE) return '일시중지'
    if (const_val === EVENT_STATUS.DONE) return '종료'
    if (const_val === EVENT_STATUS.CANCEL) return '취소'
  }

  if (Object.is(const_object, INSPECTION_STATUS)) {
    if (const_val === INSPECTION_STATUS.INIT) return '검수전'
    if (const_val === INSPECTION_STATUS.REQUEST) return '검수요청'
    if (const_val === INSPECTION_STATUS.RETURN) return '검수반려'
    if (const_val === INSPECTION_STATUS.DONE) return '검수승인'
    if (const_val === INSPECTION_STATUS.CANCEL) return '검수취소'
  }
}

const getDocName = function(type) {
  if(type){
    if(type == 1){
      return '진단서';
    }else if(type == 2){
      return '소견서';
    }else if(type == 3){
      return '진료확인서';
    }else if(type == 4){
      return '진료의뢰서';
    }
  }else{
    return '';
  }
}

//module.exports = {
export {
  ACCOUNT_TYPE,
  AUTH_TYPE,
  OS_TYPE,
  ENV,
  CONSULT_TYPE,
  CONSULT_STATUS,
  CONSULT_ACTION,
  DR_STATUS,
  PUSH_TYPE,
  MOMENT,
  ACCESS_TOKEN_KEY,
  IMG_PATH,
  USER_STATUS,
  COUNTRY_CODE,
  RES_STATUS,
  TRXN_TYPE,
  STATUS_CODE,
  UPLOAD_TYPE,
  IO_MSG,
  getConstName,
  EVENT_STATUS,
  INSPECTION_STATUS,
  getDocName
}
